var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineSearchNormal2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 11.5c0-5.65 4.6-10.25 10.25-10.25s10.25 4.6 10.25 10.25-4.6 10.25-10.25 10.25S1.25 17.15 1.25 11.5zm1.5 0c0 4.82 3.92 8.75 8.75 8.75s8.75-3.93 8.75-8.75-3.92-8.75-8.75-8.75-8.75 3.93-8.75 8.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.47 22.53-2-2a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2 2c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineSearchNormal2);
export default __webpack_public_path__ + "static/media/vuesax-outline-search-normal-2.7acd1540cb1c69242f1861038e8a1d05.svg";
export { ForwardRef as ReactComponent };